@if (versions()?.length > 1) {
  <div class="d-flex">
    {{ 'Doc::CustomerQuote:VersionNumber' | abpLocalization }}:&nbsp;
    <ng-select
      class="form-control"
      id="quoteVersion"
      [ngModel]="docId()"
      bindLabel="versionNumber"
      bindValue="docId"
      [items]="versions()"
      (change)="versionChanged($event)"
      [searchable]="false"
    >
      <ng-template ng-label-tmp let-item="item">
        @if (item) {
          {{ item.versionNumber }}
          {{ item.versionName ? '- ' + item.versionName : '' }}
        }
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        @if (item) {
          <span [title]="item.versionNumber">
            {{ item.versionNumber }}
            {{ item.versionName ? '- ' + item.versionName : '' }}</span
          >
        }
      </ng-template>
    </ng-select>
  </div>
}
